<template lang="pug">
    Button.inline-flex.items-center.justify-center.gap-2(
        class="p-3 min-w-fit whitespace-nowrap bg-gray-100"
        :class="buttonColor"
        :disabled="loading || !isActive"
        :value="value"
        @click="onClick"
    )
        span.regular-button-spinner(v-if="loading" aria-hidden="true")
        span {{ value }}
</template>

<script>
import Button from '@/components/common/buttons/button';

export default {
  name: "DefaultButton",
  props: {
      value: {
          type: String,
      },
      isActive: {
          type: Boolean,
          default: true,
      },
      color: {
        type: String,
        default: 'blue'
      },
      loading: {
        type: Boolean,
        default: false,
      },
  },
  components: {
      Button
  },
  computed: {
    buttonColor() {
      let result = ''
      if (this.loading) {
        result = `${this.colors[this.color]} text-white opacity-80 cursor-wait`
      } else if (this.isActive) {
        result = `${this.colors[this.color]} text-white`
      } else {
        result = 'text-gray-300 cursor-default'
      }

      return result
    },
    colors() {
      return {
        'blue': 'bg-accent',
        'green': 'bg-green-500',
        'gray': 'bg-gray-500',
      }
    }
  },
  methods: {
    onClick() {
      if (this.loading || !this.isActive) {
        return
      }
      this.$emit('click')
    },
  },
}
</script>

<style scoped>
.regular-button-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: regular-button-spin 0.7s linear infinite;
  flex-shrink: 0;
}

@keyframes regular-button-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>